<template>
  <ion-card button :class="`app-card  ${singleLine && 'single-line'}`" @click="goTo(service.url)">
    <div :class="`app-card-body ${mini && 'mini'}`">
      <div v-if="false" class="logo-box">
        <suite-logo :logo="service.logo" />
      </div>
      <div class="app-meta">
        <h3 class="app-title title">{{ tUseCase(service.label) }}</h3>
        <p v-if="!mini && service.description" class="app-subtitle">{{ tUseCase(service.description) }}</p>
      </div>
    </div>
  </ion-card>
</template>

<script setup lang="ts">
import {IonCard} from '@ionic/vue';
import { useNavigation } from '@/composables/useNavigation';
import {useLocale} from "@/composables/useLocale.ts";
import SuiteLogo from "@/components/SuiteLogo.vue";
import {ServiceSettings} from "@/models/settings.ts";

const { goTo } = useNavigation();
const { tUseCase } = useLocale();

const props = withDefaults(defineProps<{
  service: ServiceSettings,
  mini?: boolean,
  singleLine?: boolean
}>(),{
  mini: false,
  singleLine: false,
});

</script>

<style scoped>
/* Custom Vector Visual Representation Graphics (Shared Bar Logo) */
.logo-box {
  display: flex;
  align-items: center;
  gap: 3px;
  width: 30px;
  height: 30px;
}

/* Horizontal Style Application Grid Cards System Design */
.app-card {
  --background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: none;
  margin: 6px;
  transition: all 0.2s ease;
}

.app-card:active {
  transform: scale(0.98);
  background-color: #f8fafc;
}

.app-card-body {
  display: flex;
  align-items: center;
  padding: 14px;
  gap: 16px;
}

.app-card-body.mini {
  gap: unset;
}

.app-meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
}

.app-title {
  color: #363131;
  font-size: 1.1rem;
  margin: 0;
}

.app-subtitle {
  color: var(--font-700);
  font-size: 0.78rem;
  margin: 0;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.single-line .app-subtitle {
  text-align: end;
}

.single-line .app-meta {
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

@media (min-width: 768px) {
  .app-subtitle {
    text-align: start;
  }
}
</style>